import { useMemo, useState } from "react";
import appStyles from "../../../App.module.css";
import { benefitSummaryTableAU } from "../../config/bt-constants";

const BenefitSummaryTableModal = ({ version }: any) => {
  const [expandIndex, setExpandIndex] = useState<number | null>(null);

  const benefitList = useMemo(() => {
    return benefitSummaryTableAU;
  }, [version]);

  return (
    <div className={appStyles.btBenefitWrapper}>
      <h2 className={appStyles.btBenefitSummaryTitle}>Policy benefits</h2>
      <p className={appStyles.btBenefitSummaryDescription}>
        Underwritten by Pacific International Insurance and administered by battleface Insurance Services
      </p>
      <div className={appStyles.btAccordionWrapper}>
        {benefitList?.map((benefits: any, index: number) => (
          <div className={appStyles.btAccordionRow} key={index}>
            <div
              className={appStyles.btAccordionHeadingWrap}
              onClick={() => setExpandIndex(expandIndex === index ? null : index)}
            >
              <div>
                <div className={appStyles.btBenefitHeading}>{benefits?.name}</div>
                <div className={appStyles.btBenefitPrice}>{benefits?.benefit}</div>
              </div>
              <div>
                <span className={expandIndex === index ? appStyles.btAccordionIcon : appStyles.btAccordionOpen}></span>
              </div>
            </div>
            {expandIndex === index && <div className={appStyles.btBenefitDescription}>{benefits.description}</div>}
          </div>
        ))}
      </div>

      <p className={appStyles.btBenefitSummaryNote}>
        Note: Benefits offered are per trip per insured (unless stated otherwise). Terms, Conditions,
        Exclusions and Limitations apply. Please read the full policy wording to check that it is suitable
        for your needs.
      </p>
    </div>
  );
};

export default BenefitSummaryTableModal;